export default "__VITE_ASSET__DbHxP1IT__"